export default __webpack_public_path__ + "static/media/social-media-tw.46352576.svg";